import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { genericDocumentSentBackUpdated } from "store/actions/genericDocumentActions";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { GenericDocumentFooterProps } from "models/propTypes/documentPropTypes";
import { ActionButton } from "models/propTypes/commonPropTypes";
import { DialogEnums, StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageFooter } from "components/common";
import EditGenericDocumentFormContainer from "./forms/editGenericDocumentFormContainer";
import GenericDocumentMoreActions from "./genericDocumentMoreActions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GenericDocumentFooter: React.FC<GenericDocumentFooterProps> = (props) => {
  const { reloadDocument, markAsDeleteDocument, document } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onChangeNameSuccess = (values: WintSuperkollAPIModel.GenericDocumentPut) => {
    reloadDocument && reloadDocument();
    dispatch(genericDocumentSentBackUpdated({ ...document, description: values.subject }));
  };

  const showChangeDocumentNameDialog = async () => {
    dispatch(
      displayDialog({
        isOpen: false,
        title: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.ChangeName)}`,
        titleIcon: IconDefinitionConstants.WEdit,
        dialogType: DialogEnums.DialogType.Content,
        actions: [
          {
            text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
            successMessage: LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Document.UpdateSuccessMessage
            ),
          },
        ],
        children: <EditGenericDocumentFormContainer documentId={props.document.id} />,
        maxWidth: "sm",
        onSubmit: onChangeNameSuccess,
      })
    );
  };

  const getActionButtons = () => {
    const buttons: ActionButton[] = [];
    document.state !== WintSuperkollAPIModel.GenericDocumentState.Booked &&
      buttons.push({
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.ChangeName),
        onClick: showChangeDocumentNameDialog,
        type: StyleEnums.DisplayType.Success,
      });
    return buttons;
  };

  return (
    <PageFooter
      actions={getActionButtons()}
      moreActions={
        <GenericDocumentMoreActions
          document={props.document}
          reloadDocument={reloadDocument}
          markAsDeleteDocument={markAsDeleteDocument}
        />
      }
    />
  );
};

export default GenericDocumentFooter;
